/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeadingThin } from "components/misc/Headings.js";
import { Container } from "components/misc/Layouts";
import LineDescription from "components/texts/LineDescription";
import PageContext from "hooks/pageContext";

// const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-10 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-1/2 h-auto flex-shrink-0 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-10 sm:mt-8 md:mt-0 lg:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 xl:ml-20 md:order-last`
]);

const TextContent = tw.div`text-center md:text-left`;

const Subheading = tw(LineDescription)`font-bold `;
const Heading = tw(SectionHeadingThin)`text-left md:text-left`;
const Description = tw.p`mt-6 text-left text-lg sm:text-lg md:text-lg lg:text-lg font-medium leading-relaxed text-secondary-100`
const Text = tw.p`mt-3`



export default ({
  subheading = "",
  heading = "Fale",
  //heading2 = "Fale 2",
  submitButtonText = "Enviar",
  textOnLeft = true,
  lineDescription = "conosco",
  description = <>
    <Text>Preencha o formulário ao lado. </Text>
    <Text>Nossa equipe entrará em contato com você e apresentará uma proposta exclusiva.</Text>
    <Text>Faça parte da inovação na saúde e leve este benefício para sua empresa!</Text>
  </>
}) => {
  const { color } = useContext(PageContext);
  const targetRef = useRef(null);

  useEffect(() => {
    const createForm = () => {
      if (window.hbspt && targetRef.current) {
        targetRef.current.innerHTML = '';
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20693791",
          formId: "6f856bf5-ba0e-445a-b632-ab4bde0be5a7",
          target: `#${targetRef.current.id}`,
          inlineMessage: "<div style='text-align: center;'><h3>Tudo certo! Recebemos suas informações.</h3><p>Nossa equipe de especialistas já está analisando o seu perfil e entrará em contato muito em breve com uma proposta exclusiva para transformar a saúde na sua empresa. Até logo!</p></div>"
        });
      }
    };

    if (!window.hbspt) {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      script.async = true;
      script.onload = createForm;
      document.body.appendChild(script);
    } else {
      createForm();
    }
  }, []);

  return (
    <Container id="contato">
      <Container>
        <TwoColumn>
          <ImageColumn>
            {heading && <Heading>{heading}</Heading>}
            {lineDescription && <Subheading color={color}>{lineDescription}</Subheading>}
            { /*heading2 && <Heading>{heading2}</Heading>*/}
            <Description>{description}</Description>
          </ImageColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              <div id="hubspot-form-wrapper" ref={targetRef} style={{ width: "100%", minHeight: "650px" }}></div>
            </TextContent>
          </TextColumn>
        </TwoColumn>
      </Container>
    </Container>
  );
};
